export { default } from './CardsGrid';
export { CONFIG } from './CardsGrid.views';